import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  IconCheck,
  IconDelivery,
  IconPickUp,
  IconShield,
  IconSort,
  IconSupport,
} from '@redteclab/icons'

import { Button } from 'base-ui'

import { urlResolverGoToNfcAtShopApothekeApp } from '../../../url-handling'
import { nfcLandingPageNoWrap } from '../NfcLandingPageTranslationValues'

export const NfcLandingPageBenefitsSectionList: FC = () => {
  return (
    <div className="flex flex-col">
      <ul className="text-m text-dark-primary-max">
        <li className="mb-4 flex tablet:mb-6">
          <IconDelivery className="mr-3 size-6 shrink-0 grow-0 tablet:mr-4" />
          <span>
            <FormattedMessage
              id="nfc.benefits.benefit1.new"
              values={{
                nowrap: nfcLandingPageNoWrap,
              }}
            />
          </span>
        </li>

        <li className="mb-4 flex tablet:mb-6">
          <IconPickUp className="mr-3 size-6 shrink-0 grow-0 tablet:mr-4" />
          <span>
            <FormattedMessage id="nfc.benefits.benefit2" />
          </span>
        </li>

        <li className="mb-4 flex tablet:mb-6">
          <IconSupport className="mr-3 size-6 shrink-0 grow-0 tablet:mr-4" />
          <span>
            <FormattedMessage id="nfc.benefits.benefit3" />
          </span>
        </li>

        <li className="mb-4 flex tablet:mb-6">
          <IconSort className="mr-3 size-6 shrink-0 grow-0 tablet:mr-4" />
          <span>
            <FormattedMessage id="nfc.benefits.benefit4" />
          </span>
        </li>

        <li className="mb-4 flex tablet:mb-6">
          <IconCheck className="mr-3 size-6 shrink-0 grow-0 tablet:mr-4" />
          <FormattedMessage id="nfc.benefits.availabilityCheck" />
        </li>

        <li className="mb-4 flex tablet:mb-6">
          <IconShield className="mr-3 size-6 shrink-0 grow-0 tablet:mr-4" />
          <FormattedMessage id="nfc.benefits.benefit5" />
        </li>
      </ul>
      <Button<'a'>
        className="w-full tablet:hidden"
        href={urlResolverGoToNfcAtShopApothekeApp()}
        slots={{ root: 'a' }}
      >
        <FormattedMessage id="nfc.benefits.btn" />
      </Button>
    </div>
  )
}
